<template>
    <div class="index">
        <navbar class="nav"/>
        <intro/>
        <definicao id="definicao"/>
        <compartilhe class="mb-5"/>
        <beneficios id="beneficios"/>
        <Footer/>
    </div>
</template>

<script>

import Navbar from "@/components/navbar/index";
import Intro from "@/components/intro/index";
import Definicao from "@/components/definicao-planti/index";
import Compartilhe from "@/components/compartilhe/index";
import Beneficios from "@/components/beneficios/index";
import Footer from "@/components/footer/index";
export default {
  name: 'Index',
  components: {
      Footer,
      Beneficios,
      Compartilhe,
      Definicao,
      Intro,
      Navbar
  }
}
</script>

<style lang="scss" scoped>
.index {
    margin: 0;
    padding: 0;
}

@media screen and (max-width: 767px) {
    .nav{
        margin-bottom: 50px;
    }
}

</style>
